// extracted by mini-css-extract-plugin
export var divider = "_1s-0";
export var dividerText = "_1s-2";
export var dividerVertical = "_1s-1";